import React from "react";
import "./style.scss";
import SequenceVarinat from "../../../components/Seggregation/SequenceVaraint";
const SequenceVariantPage = () => {
  return (
    <div className="sequence_variant_page_wrapper">
      <SequenceVarinat />
    </div>
  );
};
export default SequenceVariantPage;
